import { gql } from '@apollo/client';
import { Box, SxProps } from '@mui/material';
import { ImageWithVideoFallback } from 'components/common/Image';
import { AiConversationFragmentForAiConversationSocialPostPreviewFragment } from 'graphql/generated';
import { theme } from 'styles/theme';

// eslint-disable-next-line
gql`
  fragment AiConversationFragmentForAiConversationSocialPostPreview on AIConversationModel {
    id
    previewPosts {
      id
      videoUrl
      thumbnailUrl
    }
  }
`;

const PLACEHOLDER_BACKGROUND_COLORS = [
  theme.colors?.utility['purple-1'],
  theme.colors?.utility['orange-1'],
  theme.colors?.utility['teal-1'],
];

export type AiConversationSocialPostPreviewProps = {
  aiConversation: AiConversationFragmentForAiConversationSocialPostPreviewFragment;
  sx?: SxProps;
};

export const AiConversationSocialPostPreview = (
  props: AiConversationSocialPostPreviewProps,
) => {
  const { aiConversation, sx } = props;
  const { previewPosts } = aiConversation;

  const renderPost = (index: number) => {
    const post = previewPosts?.[index];

    if (!post) {
      return (
        <Box
          sx={{
            height: '100%',
            width: '100%',
            bgcolor: PLACEHOLDER_BACKGROUND_COLORS[index],
          }}
        />
      );
    }

    return (
      <ImageWithVideoFallback
        imageUrl={post.thumbnailUrl ?? ''}
        videoUrl={post.videoUrl ?? ''}
        sx={{
          width: '100%',
          height: '100%',
          borderRadius: 2,
          objectFit: 'cover',
        }}
      />
    );
  };

  const defaultCardStyles: SxProps = {
    position: 'absolute',
    width: 42,
    height: 42,
    borderRadius: 1.5,
    border: `1px solid ${theme.colors?.primary.parchment}`,
    overflow: 'hidden',
    boxShadow:
      '0px 8px 16px -6px rgba(24, 39, 75, 0.08), 0px 6px 8px -6px rgba(24, 39, 75, 0.12)',
  };

  return (
    <Box
      sx={{
        width: 42,
        position: 'relative',
        flexShrink: 0,
        ...sx,
      }}
    >
      <Box
        sx={{
          ...defaultCardStyles,
          transform: 'translate(0, -50%) rotate(0deg)',
          zIndex: 2,
        }}
      >
        {renderPost(0)}
      </Box>
      <Box
        sx={{
          ...defaultCardStyles,
          transform: 'translate(-10%, -62%) rotate(-7deg)',
          zIndex: 1,
        }}
      >
        {renderPost(1)}
      </Box>
      <Box
        sx={{
          ...defaultCardStyles,
          transform: 'translate(-17%, -78%) rotate(-10deg)',
          zIndex: 0,
        }}
      >
        {renderPost(2)}
      </Box>
    </Box>
  );
};
